import { useQuery } from '@tanstack/react-query';
import { FundDocument } from '../types';

type FundDocumentsProps = {
  fundId: string;
};

export const useFundDocuments = ({ fundId }: FundDocumentsProps) => {
  const { data, isLoading, refetch, error, isError } = useQuery<FundDocument[]>({
    queryKey: ['funds', fundId, 'files'],
  });

  return {
    documents: data ?? [],
    isLoading,
    refetch,
    error,
    isError,
  };
};
